export const UndoButton = (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ bottom: 20, left: 20, position: "fixed" }}
  >
    <path
      d="M7.59445 8.8854L3.88379 10.9421L1.82692 7.23143"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.29712 10.5C4.29712 5.25329 8.55041 1 13.7971 1C19.0438 1 23.2971 5.25329 23.2971 10.5C23.2971 15.7467 19.0438 20 13.7971 20C10.1785 20 7.0325 17.9769 5.42843 15"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M13.2971 7V11.5L16.2971 14"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);
